// extracted by mini-css-extract-plugin
export default {"SuggestionContainer":"hrom6K","suggestionContainer":"hrom6K"};